import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@mote/ui'
import { __DEV__ } from '@mote/helpers/constants'

export const AccountPaginator = ({ pageIndex, pageIndexes = [] }) => {
  const history = useHistory()

  function pageLink(index, label) {
    if (!label) {
      label = index + 1
    }
    const newSearchParams = window.location.search.replace(
      `page=${pageIndex}`,
      `page=${index}`
    )

    return (
      <Button
        variant='link'
        onClick={_ => {
          history.push({
            pathname: window.location.pathname,
            search: newSearchParams
          })
        }}
        text={label}
      />
    )
  }

  if (Number.isNaN(pageIndex)) {
    if (__DEV__) throw new Error('Page number provided is not a number')
    return null
  }

  if (pageIndexes.length < 2) {
    return null
  }

  const lastPageIndex = parseInt(pageIndexes[pageIndexes.length - 1]) - 1
  const pageIndexParsed = parseInt(pageIndex)

  return (
    <div>
      <p style={{ textAlign: 'center' }}>
        {pageIndexParsed > 0 && pageLink(pageIndexParsed - 1, 'Previous')}
        {pageIndexes.map(pageNumber => {
          const isCurrentOrEllipsis =
            pageNumber === '...' || pageNumber - 1 === pageIndexParsed

          return (
            <React.Fragment key={pageNumber}>
              <span>
                {' '}
                {isCurrentOrEllipsis && <span>{pageNumber}</span>}
                {!isCurrentOrEllipsis && pageLink(pageNumber - 1)}
              </span>
            </React.Fragment>
          )
        })}{' '}
        {pageIndexParsed < lastPageIndex &&
          pageLink(pageIndexParsed + 1, 'Next')}
      </p>
    </div>
  )
}
